//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { bagItemDesc } from "@/api/financial/consumptionDetails";
import { template } from "lodash";
import { mapState } from "vuex";
import watchRewardDetail from "./watchRewardDetail.vue";
export default {
  name: 'watchBackPackDetails',
  components: {
    watchRewardDetail: watchRewardDetail
  },
  data: function data() {
    return {
      dialogShow: false,
      list: []
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      console.log("data===", data);
      this.list = JSON.parse(JSON.stringify(data.gift_code_use));
      this.dialogShow = true;
    }
  }
};